import { robot } from '../assets';

const Hero = () => (
  <section className="hero">
    <div className="left">
      <h1><span>decentralot</span><br/>
        The First<br/>
        Polygon Lottery<br/>
        with 95% Payout.</h1>
      <p>95% of the amount of bets are sent back to the winners:<br/>
        - 80% for the current lottery's winner<br/>
        - 10% for the next lottery's winner<br/>
        - 5% for the winner picker of the current lottery (the one who clicks first on the "pick winner" button)</p>
    </div>
    <div className="right">
      <figure>
        <img src={robot} alt="Rich Robot"/>
        <figcaption>Credits: <a target="_blank" rel="noreferrer" href="https://www.freepik.com/author/katemangostar">Katemangostar / Freepik</a> / <a target="_blank" rel="noreferrer" href="https://www.jsmastery.pro/">JSMastery</a></figcaption>
      </figure>


      <div className="pink-gradient"></div>
    </div>
  </section>
)

export default Hero